import { isValid } from "date-fns";
import React from "react";
import TimePicker, {
  type TimePickerProps,
} from "@/components/common/datetimePicker/TimePicker";
import { combineDateAndTime } from "@/utils/date";

type Props = Omit<TimePickerProps, "onAccept"> & {
  value: Date;
  onTimeChange: React.Dispatch<Date>;
};

export const SmallTimeSelector = ({ value, onTimeChange, ...props }: Props) => {
  const handleTimeChange = (newDate: Date, prevDate: Date) => {
    // keep the date part of the previous date, update only the time part
    onTimeChange(combineDateAndTime(new Date(prevDate), newDate));
  };

  return (
    <TimePicker
      {...props}
      aria-label={props.label}
      label={null}
      sx={{
        "& .MuiInputBase-input": {
          height: "44px",
          padding: "9px 12px",
          boxSizing: "border-box",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          top: "0px",
        },
        "& .MuiOutlinedInput-notchedOutline legend": {
          display: "none",
        },
      }}
      value={value}
      onAccept={(date: Date) => {
        if (isValid(date)) {
          handleTimeChange(date, value);
        }
      }}
    />
  );
};
